"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TitleAndDescriptions;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function TitleAndDescriptions(_ref) {
  var {
    title,
    defaultTitle,
    description,
    secondaryDescription
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title || defaultTitle ? /*#__PURE__*/_react.default.createElement("h2", null, title ? (0, _htmlReactParser.default)(title) : defaultTitle) : '', description && /*#__PURE__*/_react.default.createElement("h4", null, (0, _htmlReactParser.default)(description)), secondaryDescription && /*#__PURE__*/_react.default.createElement("p", {
    className: "secondaryDescription"
  }, (0, _htmlReactParser.default)(secondaryDescription)));
}